var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

var template = require('./MemberProfileButtonsEdit.jinja');
require('./MemberProfileButtonsEdit.less');

module.exports = Base.extend({

    template: template,

    events: {
        'click .MemberProfileButtonsEdit-itemEdit': 'onClickEdit',
        'click .MemberProfileButtonsEdit-itemEye': 'onClickHidden'
    },


    saveApi: function () {
        return Urls['member:api:member'](this.memberId, 'json');
    },


    initialize: function (options) {
        this.options = options || {};

        this.memberId = this.$el.attr('data-memberid') - 0;

        _.bindAll(this, 'saveApi');

        Base.prototype.initialize.call(this, options);
    },


    onClickEdit: function (e) {
        var block = $(e.currentTarget)
                        .parent()
                        .data('block');

        window.app.vent.trigger('MemberProfileEdit--open', block);
    },


    onClickHidden: function (e) {
        var $icon = $(e.currentTarget);
        var block = $icon.parent().data('block');
        var memberData = window.app.data.members[this.memberId];
        var fieldName;

        /*eslint-disable */
        switch (block) {
            case 'bio':         fieldName = 'bioPublic'; break;
            case 'skills':      fieldName = 'skillsPublic'; break;
            case 'experience':  fieldName = 'experiencesPublic'; break;
            case 'recognition': fieldName = 'recognitionsPublic'; break;
            case 'location':    fieldName = 'locationsPublic'; break;
            case 'credits':     fieldName = 'creditsPublic'; break;
            case 'portfolio':   fieldName = 'portfolioPublic'; break;
        }
        /*eslint-enable */

        var currentPublicState = memberData[fieldName];
        var newPublicState = !currentPublicState;

        var data = {};
        data[fieldName] = newPublicState;

        $icon.addClass('loading');

        this.saveXhr = $.ajax({
            url: this.saveApi(),
            method: 'PATCH',
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            data: JSON.stringify(data),
            success: function (responseData) {

                app.vent.trigger('need-reload', 'my-adg');// refresh my-adg page if it's current underlying page, to update member info block on it

                $icon.removeClass('loading');

                //save response to cache, it's important for all popup edit panels, which renders on the fly to show actual data
                //response always contain all profile data up-to-date
                window.app.data.members[this.memberId] = responseData;

                var isPublic = responseData[fieldName];

                $icon.toggleClass('hidden', !isPublic);

                window.app.vent.trigger('MemberProfileEdit--hidden', block, !isPublic);
            },
            error: function (e, tp) {
                $icon.removeClass('loading');

                if (tp != 'abort') {
                    alert('Can\'t update public/private!');
                }

                console.log('error', arguments);
            },
            context: this
        });
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/MemberProfileButtonsEdit/MemberProfileButtonsEdit.js
// module id = 16
// module chunks = 0